import _ from 'lodash';
import React from 'react';

import {
  Box,
  Card as BaseCard,
  CardContent as BaseCardContent,
  Stack,
  styled,
  Typography
} from '@mui/material';
import {
  activityTemplates,
  AuthWrapper,
  DecorativeHeaderText,
  ExternalLink,
  imageUtil,
  ResponsiveImage,
  SectionContainer
} from 'modules';

import * as ResourceFeedbackSection from './components/ResourceFeedbackSection/ResourceFeedbackSection';
import imgfeedbackBackground from 'assets/images/background-resources-feedback.png';
import data from './data.json';



const imgsCardBkgd = imageUtil.getUrlSet('card_background', 'png');
const imgsNews = imageUtil.getUrlSet('news', 'png');
const imgPageBkgd = imageUtil.getUrl('before_and_after', 'png');



const CompanyCard = styled(BaseCard)(({ theme }) => ({
  backgroundImage: `url(${_.last(imgsCardBkgd)})`,
  backgroundSize: 'cover',
  width: 310,
  height: 156
}));



const CardContent = styled(BaseCardContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '100%'
}));



const CompanyCardTitle = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  color: 'white',
  textAlign: 'center'
}));



const Card = styled(BaseCard)(({ theme }) => ({
  width: 310,
  height: 344
}));



const ContentTypography = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  textAlign: 'center',
  color: 'black',
  marginTop: theme.spacing(3)
}));


const ContainerBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));

const HeaderTypography = styled(Typography)(({ theme }) => ({
  color: 'white',
  maxWidth: '860px',
  textAlign: 'center',
  marginBottom: theme.spacing(2)
}));



const ResourceFeedbackBackgroundBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(12),
  marginBottom: theme.spacing(12),
  height: 270,
  borderRadius: 10,
  backgroundImage: `url(${imgfeedbackBackground})`,
  backgroundSize: 'cover',
  marginRight: 60
}));

export interface IBeforeAndAfterActivityProps {}

export const BeforeAndAfterActivity: React.FC<IBeforeAndAfterActivityProps> = props => {
  return (
    <AuthWrapper.FC>
      <activityTemplates.BaseActivityTemplate.FC
        colorVariant="dark"
        backgroundSize="contain"
        imgBackground={imgPageBkgd}>
        <SectionContainer.FC
          marginTop="calc(100vw * 0.15 - 112px)"
          marginBottom="calc(100vw * 0.28 - 224px)">
          <HeaderTypography variant="h1">
          Before + After Resources
          </HeaderTypography>

          <HeaderTypography>
          Preparing for the first fundraise or working toward company milestones following a raise? Check out potential partners and relevant blog posts to help evolve your business.
          </HeaderTypography>
        </SectionContainer.FC>

        {_.map(data, sectionInfo => (
          <SectionContainer.FC key={sectionInfo.sectionTitle}>
            <DecorativeHeaderText.FC label={sectionInfo.sectionTitle} />

            <Stack spacing={9}>
              {_.map(sectionInfo.data, (sectionData, i) => (
                <section key={i}>
                  <Stack spacing={3}>
                    <Typography variant="h2">{sectionData.title}</Typography>

                    <Stack spacing={4}>
                      <Typography>{sectionData.description}</Typography>

                      <Stack
                        direction="row"
                        spacing={2}>
                        {_.map(sectionData.companies, (company, i) => (
                          <CompanyCard
                            key={i}
                            elevation={0}>
                            <CardContent>
                              <CompanyCardTitle>
                                {company.name}
                              </CompanyCardTitle>

                              <ExternalLink.Button href={company.url}>
                              Learn More
                              </ExternalLink.Button>
                            </CardContent>
                          </CompanyCard>
                        ))}
                      </Stack>

                      <Stack
                        direction="row"
                        spacing={2}>
                        {_.map(sectionData.resources, (r, i) => (r.url ? (
                          <Card
                            key={i}
                            elevation={4}>
                            <CardContent>
                              <ContainerBox>
                                <Box>
                                  <ResponsiveImage.FC urlSet={imgsNews} />
                                </Box>

                                <ContentTypography>
                                  {r.text}
                                </ContentTypography>
                              </ContainerBox>

                              <ExternalLink.Button
                                outlined
                                href={r.url}>
                              Read More
                              </ExternalLink.Button>
                            </CardContent>
                          </Card>
                        ) : (
                          <Card key={i} elevation={0} />
                        )))}
                      </Stack>
                    </Stack>
                  </Stack>
                </section>
              ))}
            </Stack>
          </SectionContainer.FC>
        ))}

        <ResourceFeedbackBackgroundBox>
          <ResourceFeedbackSection.FC />
        </ResourceFeedbackBackgroundBox>
      </activityTemplates.BaseActivityTemplate.FC>
    </AuthWrapper.FC>
  );
};
